//
//
// https://react-redux.js.org/tutorials/quick-start
//
//
import { createSlice } from "@reduxjs/toolkit";

export const tester = createSlice({
  name: "tester",
  initialState: {
    value: 1
  },
  reducers: {
    increment: state => {
      state.value += 1;
    },
    decrement: state => {
        state.value -= 1;
      }
  }
});

export const { increment,decrement } = tester.actions;

export default tester.reducer;
